<template>
    <div class="container">

        <div class="row">
            <div class="col-md-12 mt-2 mb-3">
                <h1>
                    <span v-if="editMode">Urejanje evelvacije dogodka</span>
                    <span v-if="!editMode">Dodajanje evalvacije dogodka</span>
                </h1>

            </div>
        </div>

        <div class="row">
            <div class="col-md-12">

                <!--                current step: {{event.currentFormStep}}<br/>-->
                <!--                {{errors}}-->

                <div>


                            <div class="card-body">
                                <div class="row">
                                    <div class="col-md-12">

                                        <b-form-group
                                                label="Določi datum in čas dogodka"
                                                label-for="date"
                                                :class="{'is-invalid': errors.has('date')}">

                                            <VueCtkDateTimePicker id="date" name="date" key="date"
                                                                  format="YYYY-MM-DDTHH:mm:ssZ"
                                                                  class="withLabel" locale="sl"
                                                                  formatted="dddd, Do MMMM YYYY, HH:mm"
                                                                  label="Datum in čas dogodka"
                                                                  v-model="event.date"
                                                                  v-validate="'required'"
                                            />

                                            <div class="invalid-feedback" v-if="errors.has('date')">
                                                Polje ne sme biti prazno.
                                            </div>
                                        </b-form-group>



                                        <b-form-group
                                                id="nameLabel"
                                                label="Vnesi naziv dogodka"
                                                label-for="name"
                                                :class="{'is-invalid': errors.has('addressName')}">
                                            <b-form-input
                                                    id="name"
                                                    name="name"
                                                    v-model="event.name"
                                                    placeholder="naziv dogodka"
                                                    v-validate="'required'"
                                                    trim></b-form-input>
                                            <div class="invalid-feedback" v-if="errors.has('name')">
                                                Polje ne sme biti prazno.
                                            </div>
                                        </b-form-group>

                                        <b-form-group
                                                id="address"
                                                label="Vnesi naslov lokacije dogodka"
                                                label-for="address"
                                                :class="{'is-invalid': errors.has('address')}">

                                            <GmapAutocomplete
                                                    id="address"
                                                    ref="autocomplete"
                                                    @place_changed="onPlaceChanged"
                                                    :value="event.location"
                                                    placeholder="vnesi naslov" class="form-control"
                                                    @input="value = $event.target.value"></GmapAutocomplete>

                                            <b-form-input
                                                    style="display: none"
                                                    name="address"
                                                    v-model="event.address"
                                                    v-validate="'required'"
                                                    trim></b-form-input>

                                            <div class="invalid-feedback" v-if="errors.has('address')">
                                                Polje ne sme biti prazno.
                                            </div>
                                        </b-form-group>

                                        <b-form-group
                                                label="Opis dogodka"
                                                label-for="description"
                                                :class="{'is-invalid': errors.has('description')}">
                                                <textarea v-model="event.description" id="description" name="description"
                                                          placeholder="opis dogodka" class="form-control"
                                                          style="height: auto"
                                                          required rows="5" v-validate="'required'"> </textarea>
                                            <div class="invalid-feedback" v-if="errors.has('description')">
                                                Polje ne sme biti prazno.
                                            </div>
                                        </b-form-group>

                                      <b-form-group label="Glasovanje omogočeno?">
                                        <div>
                                          <b-form-checkbox
                                              v-model="event.votingEnabled"
                                              size="lg"
                                              switch> Glasovanje omogočeno
                                          </b-form-checkbox>
                                        </div>
                                      </b-form-group>


                                      <div class="row" v-if="event && event.votes && event.votes.length > 0">
                                        <div class="col-md-12 mt-5">
                                          <div class="table-responsive">
                                            <h4>Oddani glasovi</h4>
                                            <table class="table table-striped">
                                              <thead>
                                              <th>#</th>
                                              <th>čas oddaje glasu</th>
                                              <th>ocena</th>
                                              </thead>
                                              <tbody>
                                              <tr v-for="(vote,index) in event.votes" :key="'vote_' + index">
                                                <td>{{index+1}}</td>
                                                <td>{{moment.unix(vote.votedAt.seconds).format('DD. MM. YYYY, HH:mm:ss')}}</td>
                                                <td>
                                                  {{vote.score}}

                                                  <span v-for="item in new Array(vote.score)">
                                                    <i class="fa fa-thumbs-up text-success mx-1" v-if="vote.score === 3"></i>
                                                    <i class="fa fa-thumbs-up text-info mx-1" v-if="vote.score === 2"></i>
                                                    <i class="fa fa-thumbs-up text-danger mx-1" v-if="vote.score === 1"></i>
                                                  </span>

                                                </td>
                                              </tr>
                                              </tbody>
                                            </table>

                                            <h6><small>Število glasov:</small> {{event.votes.length}}</h6>
                                            <h6><small>Povprečna ocena:</small> {{getAverageVal(event.votes)}}</h6>
                                          </div>
                                        </div>
                                      </div>

                                    </div>
                                </div>
                            </div>


                </div>
            </div>
        </div>


        <div class="row">
            <div class="col-md-12 mt-3">
                <div class="d-flex">
                    <button v-if="editMode" class="btn btn-danger mr-auto" @click="deleteEventConfirmation()"><i
                            class="fa fa-trash"></i>
                        Izbriši
                        evalvacijo dogodek
                    </button>

                    <button v-if="!editMode" type="submit" @click="addEvent()" class="btn btn-info ml-auto"><i
                            class="fa fa-save"></i> Shrani podatke o evalvaciji dogodku
                    </button>


                    <button v-if="editMode" type="submit" @click="updateEvent()" class="btn btn-info ml-auto"><i
                            class="fa fa-save"></i> Posodobi podatke o evalvaciji dogodku
                    </button>
                </div>

                <div>

                    <router-link :to="{ name: 'EventEvaluation'}" class="btn btn-link pt-4">
                        Prekliči
                    </router-link>

                </div>
            </div>
        </div>



    </div>
</template>


<script>
  import firebase from 'firebase'
  import {db} from '../main'
  import vSelect from 'vue-select'
  import 'vue-select/dist/vue-select.css'
  import Multiselect from 'vue-multiselect'
  import 'vue-multiselect/dist/vue-multiselect.min.css'

  export default {
    name: 'EditEvent',
    components: {
      vSelect,
      Multiselect
    },
    data () {
      return {
        event: {
          id: '',
          updatedAt: null,
          updatedBy: '',
          createdAt: null,
          createdBy: '',
          currentFormStep: null,

          // step 1
          name: null,
          location: null,
          date: this.moment().format('YYYY-MM-DDTHH:mm:ssZ'),
          description: null,
          votes: [],
          votingEnabled: true,

        },
        roles: this.$store.getters.getRoles,
        projects: this.$store.getters.getProjects,
        id: this.$route.params.id,
        users: this.$store.getters.getUsers,
        editMode: false,
        vkr: {
          servicesAndGoods: []
        },
        vkrIndex: null,
        servicesAndGoodsIndex: null
      }
    },
    computed: {
      validationRuleMultipleDayEvent () {
        console.log("multipleDayEvent", this.event.multipleDayEvent);
        return this.event.multipleDayEvent ? 'required' : ''
      },
      validationRuleRegistrationRequired () {
        return this.event.registrationRequired ? 'required' : ''
      },
      validationRuleMaxParticipants () {
        return this.event.maxParticipantsLimit ? 'required' : ''
      }
    },
    mounted () {
      const _this = this

      if (_this.id) {
        _this.editMode = true
        _this.loadEvent()
      } else {
        _this.editMode = false
      }

      if (_this.$store.getters.getProjects.length === 0) {
        _this.$store.dispatch('retrieveProjects').then(() => {
          _this.projects = _this.$store.getters.getProjects
        })
      }

      if (_this.$store.getters.getRoles.length === 0) {
        _this.$store.dispatch('retrieveRoles').then(() => {
          _this.roles = _this.$store.getters.getRoles
        })
      }

      if (_this.$store.getters.getUsers.length === 0) {
        _this.$store.dispatch('retrieveUsers').then(() => {
          _this.users = _this.$store.getters.getUsers
        })
      }

      // _this.$refs.autocomplete.$on('place_changed', (res) => {
      //   console.log(res)
      //
      //   // _this.address.route = _this.getGeocompleteData(res, 'route');
      //   // _this.address.street_number = _this.getGeocompleteData(res, 'street_number');
      //   // _this.address.postal_code = _this.getGeocompleteData(res, 'postal_code');
      //   // _this.address.postal_town = _this.getGeocompleteData(res, 'postal_town');
      //   _this.event.municipality = _this.getGeocompleteData(res, 'administrative_area_level_1')
      //   // _this.address.country = _this.getGeocompleteData(res, 'country');
      //
      //   _this.event.address = res.formatted_address
      //
      //   console.log(_this.$refs.autocomplete)
      // });

      // _this.loadRoles()
      // _this.loadProjects()

    },
    methods: {

      onPlaceChanged (res) {
        const _this = this

        console.log(res)
        _this.event.location = res.formatted_address
      },
      getOptionLabel (option) {
        console.log(option)
        return this.getReadableUser(option.id)
      },

      loadEvent () {
        const _this = this

        db.collection('eventEvaluation')
          .doc(this.id)
          .get()
          .then(snapshot => {
            const document = snapshot.data()

            _.forOwn(document, function (value, key) {
              if (key === 'date') {
                document[key] = value ? _this.moment.unix(value.seconds).format('YYYY-MM-DDTHH:mm:ssZ') : null
              } else if (key === 'address') {
                _this.$refs.autocomplete.$refs.input.value = value // manually set init GmapAutocomplete value
                console.log(_this.$refs.autocomplete)
              }
            })

            _this.event = document
console.log("this.event", _this.event);

          })

      },

      checkDateConfirmedValue () {
        const _this = this

        console.log('_this.event.dateConfirmed', _this.event.dateConfirmed)


      },

      async updateEvent () {
        const _this = this
        const currentEvent = db.collection('eventEvaluation').doc(this.id)

        // await _this.validateFields()

        // if (_this.errors.items.length > 0) {
        //   await _this.$swal('Manjkajoči podatki', 'Preverite, če ste vnesli vse potrebne podatke!', 'error', {dangerMode: true})
        //   return false
        // }

        return currentEvent.update({
          // step1
          id: _this.event.id ? _this.event.id : _this.id,
          name: _this.event.name,
          location: _this.event.location,
          date: _this.moment(_this.event.date, 'YYYY-MM-DDTHH:mm:ssZ').toDate(),
          description: _this.event.description,
          votes: _this.event.votes,
          votingEnabled: _this.event.votingEnabled
        })
          .then(function () {
            // _this.$store.dispatch('retrieveEvents', true).then(() => {
            _this.$router.push({name: 'EventEvaluation'})
            // })

          })
          .catch(function (error) {
            // The document probably doesn't exist.
            console.error('Error updating event: ', error)
          })

      },

      async addEvent () {
        const _this = this

        // await _this.validateFields()

        // if (_this.errors.items.length > 0) {
        //   await _this.$swal('Manjkajoči podatki', 'Preverite, če ste vnesli vse potrebne podatke!', 'error', {dangerMode: true})
        //   return
        // }

        let ref = db.collection('eventEvaluation').doc()
        ref.set({id: ref.id}) // set new document ID
          .then(() => {  // fetch the doc again and show its data
            ref.get().then(doc => {

              _this.id = doc.data().id
              _this.event.createdAt = new Date()
              _this.event.createdBy = JSON.parse(sessionStorage.getItem('DP_user')).id
              _this.updateEvent()
            })
          })

      },

      async validateFields () {
        let _this = this

        // _this.$validator.validate('project', _this.event.project).then(result => {
        //   console.log(result);
        // });

        if (_this.event.currentFormStep === null || _this.event.currentFormStep === 1) {
          await _this.$validator.validate('project', _this.event.project)
          await _this.$validator.validate('dateConfirmed', _this.event.dateConfirmed)
          await _this.$validator.validate('date', _this.event.date)
          _this.event.multipleDayEvent ? await _this.$validator.validate('endDate', _this.event.endDate) : null
          await _this.$validator.validate('addressName', _this.event.addressName)
          await _this.$validator.validate('address', _this.event.address)
          await _this.$validator.validate('municipality', _this.event.municipality)
          await _this.$validator.validate('activities', _this.event.activities)

        } else if (_this.event.currentFormStep === 2) {
          await _this.$validator.validate('project', _this.event.project)
          await _this.$validator.validate('dateConfirmed', _this.event.dateConfirmed)
          await _this.$validator.validate('date', _this.event.date)
          _this.event.multipleDayEvent ? await _this.$validator.validate('endDate', _this.event.endDate) : null
          await _this.$validator.validate('addressName', _this.event.addressName)
          await _this.$validator.validate('address', _this.event.address)
          await _this.$validator.validate('municipality', _this.event.municipality)
          await _this.$validator.validate('activities', _this.event.activities)

          await _this.$validator.validate('eventName', _this.event.eventName)
          await _this.$validator.validate('description', _this.event.description)
          _this.event.registrationRequired ? await _this.$validator.validate('registrationLink', _this.event.registrationLink) : null
          _this.event.maxParticipantsLimit ? await _this.$validator.validate('maxParticipants', _this.event.maxParticipants) : null
          await _this.$validator.validate('notes', _this.event.notes)
          await _this.$validator.validate('financesCoverage', _this.event.financesCoverage)

        } else if (_this.event.currentFormStep === 3) {
          await _this.$validator.validate('project', _this.event.project)
          await _this.$validator.validate('dateConfirmed', _this.event.dateConfirmed)
          await _this.$validator.validate('date', _this.event.date)
          _this.event.multipleDayEvent ? await _this.$validator.validate('endDate', _this.event.endDate) : null
          await _this.$validator.validate('addressName', _this.event.addressName)
          await _this.$validator.validate('address', _this.event.address)
          await _this.$validator.validate('municipality', _this.event.municipality)
          await _this.$validator.validate('activities', _this.event.activities)

          await _this.$validator.validate('eventName', _this.event.eventName)
          await _this.$validator.validate('description', _this.event.description)
          _this.event.registrationRequired ? await _this.$validator.validate('registrationLink', _this.event.registrationLink) : null
          _this.event.maxParticipantsLimit ? await _this.$validator.validate('maxParticipants', _this.event.maxParticipants) : null
          await _this.$validator.validate('notes', _this.event.notes)
          await _this.$validator.validate('financesCoverage', _this.event.financesCoverage)

        }

        // if(_this.errors.items.length > 0) {
        //   return false
        // } else {
        //   return true
        // }

      },
      deleteEventConfirmation () {
        const _this = this

        this.$swal({
          title: 'Opozorilo',
          text: 'Ali ste prepričani, da želite izbrisati dogodek, vnešen za dan  ' + _this.moment(_this.event.date).format('DD. MM. YYYY, HH:mm') + '? Po potrditvi izbire ne bo več mogoče preklicati.',
          dangerMode: true,
          buttons: {
            cancel: {
              text: 'Prekliči',
              value: null,
              visible: true,
              className: '',
              closeModal: true,
            },
            confirm: {
              text: 'Izbriši',
              value: true,
              visible: true,
              className: '',
              closeModal: true
            }
          },
        })
          .then((value) => {

            switch (value) {

              case true:

                _this.deleteEvent()

              case null:

                return

                break

              default:

            }
          })
      },
      deleteEvent () {
        const _this = this

        db.collection('events').doc(_this.id).delete()
          .then(function () {
            _this.$router.push({name: 'Events'})
          })
          .catch(function (error) {
            // The document probably doesn't exist.
            console.error('Error deleting event: ', error)
          })
      },

      getGeocompleteData (result, searchItem) {
        let geocompleteData = ''

        if (typeof (_.find(result.address_components, function (ac) {
          return ac.types[0] == searchItem
        })) != 'undefined') {
          geocompleteData = (_.find(result.address_components, function (ac) {
            return ac.types[0] == searchItem
          }).long_name)
        }
        console.log(geocompleteData)
        return geocompleteData
      },

      getReadableUser (userId) {
        const _this = this

        let userObj = _.filter(_this.users, {'id': userId})[0]
        if (userObj) {
          return userObj.first_name + ' ' + userObj.last_name
        } else {
          return 'n/a'
        }
      },

      editVkrItem (index) {
        const _this = this

        if (index === null) {
          _this.vkr = {
            index: null,
            receiptNumber: '',
            vkrNumber: '',
            setNumber: '',
            amount: null,
            servicesAndGoods: []
          }
          _this.vkrIndex = 0

        } else {
          _this.vkr = {
            index: index,
            receiptNumber: _this.event.vkrData[index].receiptNumber,
            vkrNumber: _this.event.vkrData[index].vkrNumber,
            setNumber: _this.event.vkrData[index].setNumber,
            amount: parseFloat(_this.event.vkrData[index].amount).toFixed(2),
            servicesAndGoods: _this.event.vkrData[index].servicesAndGoods,
          }
          _this.vkrIndex = index
        }
        _this.calculateSum();
        _this.showVkrModal()

      },

      deleteVkrItem (index) {
        const _this = this

        _this.event.vkrData.splice(index, 1)
      },

      updateVkrData () {
        const _this = this

        console.log("updateVkrData");

        if (_this.vkr.index === null) {
          delete _this.vkr.index
          _this.event.vkrData.push(_this.vkr)
        } else {
          _this.event.vkrData[_this.vkr.index] = _this.vkr
          delete _this.event.vkrData[_this.vkr.index].index
        }

        _this.servicesAndGoodsIndex = null;
        _this.closeModal()
      },

      showVkrModal () {
        this.$refs['vkr-modal'].show()
      },

      closeModal () {
        const _this = this

        if (_this.$refs['vkr-modal']) {
          _this.$refs['vkr-modal'].hide()
          _this.vkr = {}
        }
      },

      showVkrServicesAndGoodsModal () {
        this.$refs['vkr-servicesAndGoodsModal'].show()
      },

      closeVkrServicesAndGoodsModal () {
        const _this = this

        if (_this.$refs['vkr-servicesAndGoodsModal']) {
          _this.$refs['vkr-servicesAndGoodsModal'].hide()
          // _this.servicesAndGoodsIndex = null;
        }
      },

      editVkrServicesAndGoodsItems (index) {
        const _this = this

        console.log('index', index)
        console.log('_this.vkrIndex', _this.vkrIndex)

        console.log('_this.vkr', _this.vkr)
        console.log('_this.event', _this.event)
        console.log('vkrData', _this.event.vkrData)
        console.log('vkrData @ index', _this.event.vkrData[_this.vkrIndex])

        if (index === null) {
          _this.vkr.servicesAndGoods.push({
            index: _this.vkr.servicesAndGoods.length + 1,
            serviceOrGood: '',
            pricePerItem: 0,
            numberOfItems: 0,
            price: 0
          })
          _this.servicesAndGoodsIndex = _this.vkr.servicesAndGoods.length-1;

        } else {
          _this.servicesAndGoodsIndex = index
          _this.vkr.servicesAndGoods[index] = {
            index: index,
            serviceOrGood: _this.vkr.servicesAndGoods[index].serviceOrGood,
            pricePerItem: _this.vkr.servicesAndGoods[index].pricePerItem,
            numberOfItems: _this.vkr.servicesAndGoods[index].numberOfItems,
            price: parseFloat(_this.vkr.servicesAndGoods[index].price).toFixed(2),
          }
        }
        _this.showVkrServicesAndGoodsModal()
      },

      deleteVkrServicesAndGoodsItems(index) {
        const _this = this

        _this.vkr.servicesAndGoods.splice(index, 1)
      },

      updateVkrServicesAndGoodsData () {
        const _this = this

        console.log('--->', _this.vkr.servicesAndGoods[_this.servicesAndGoodsIndex])

        _this.calculateSum();
        _this.$forceUpdate();
        _this.closeVkrServicesAndGoodsModal()
      },

      calculateSum() {
        const _this = this;

        let total = 0;
        _.map(_this.vkr.servicesAndGoods, function (val) {
            total += val.price
        });

        _this.vkr.amount = total;
      },

      getAverageVal(votes) {
        return _.meanBy(votes, (p) => p.score).toFixed(2);
      }

    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/EditEventEvaluation.vue